__turbopack_context__.v({
  "backgroundLightGrey": "WinWithFriendsBadge-module__Du_PVa__backgroundLightGrey",
  "backgroundWhite": "WinWithFriendsBadge-module__Du_PVa__backgroundWhite",
  "badgeImage": "WinWithFriendsBadge-module__Du_PVa__badgeImage",
  "badgeText": "WinWithFriendsBadge-module__Du_PVa__badgeText",
  "chevron": "WinWithFriendsBadge-module__Du_PVa__chevron",
  "container": "WinWithFriendsBadge-module__Du_PVa__container",
});
